/*
  Automatically instantiates modules based on data-attrubiutes
  specifying module file-names.
*/

import absolutepositioning from "./absolutepositioning";
import anchorlinks from "./anchorlinks";
import autocomplete from "./autocomplete";
import collapseelement from "./collapseelement";
import dropdownmenutoggle from "./dropdownmenutoggle";
import facettoggle from "./facettoggle";
import fbshare from "./fbshare";
import lazyloader from "./lazyloader";
import lookup_person from "./lookup_person";
import menutoggle from "./menutoggle";
import navigation from "./navigation";
import playfilter from "./playfilter";
import submenutoggle from "./submenutoggle";
import toggleiframemodal from "./toggleiframemodal";

const modules = {
  absolutepositioning,
  anchorlinks,
  autocomplete,
  collapseelement,
  dropdownmenutoggle,
  facettoggle,
  fbshare,
  lazyloader,
  lookup_person,
  menutoggle,
  navigation,
  playfilter,
  submenutoggle,
  toggleiframemodal,
};

document.addEventListener("DOMContentLoaded", () => {
  let handler = () => {
    let elements = document.querySelectorAll(`[data-module]`);
    elements.forEach((element) => {
      if (element.dataset.moduleInitialized) {
        return;
      }
      const name = element.dataset.module;
      if (!name || !modules[name]) {
        return;
      }
      let Module = modules[name];
      new Module(element);
      element.dataset.moduleInitialized = true;
    });
  };
  let rootElement = document.getElementById("root");
  if (rootElement) {
    let observer = new MutationObserver(handler);
    observer.observe(rootElement, { childList: true });
  }
  handler();
});
